:host {
  display: block;
  grid-column: span 12;
  max-width: 100%;

  @include breakpoint($medium) {
    grid-column: auto / span var(--grid-element-span, 12);
  }

  ::slotted(*:not(ui-cms-anchor):not(ui-fund-portrait)) {
    margin-top: 30px;
  }

  ::slotted(*:first-child:not(ui-cms-sub-layout)) {
    margin-top: 0;
  }

  ::slotted(ui-cms-anchor ~ :nth-child(2)) {
    margin-top: 0;
  }
}

:host([centered]) {
  @include breakpoint($medium) {
    grid-column: var(--start-column, 0) / span var(--grid-element-span, 12);
  }
}

:host([reduced-spacing]) {
  margin-bottom: calc(var(--grid-row-gap-reduction, 60) * -1px);
}
